import { render, staticRenderFns } from "./EpopsModal.vue?vue&type=template&id=13640d03&scoped=true"
import script from "./EpopsModal.vue?vue&type=script&lang=js"
export * from "./EpopsModal.vue?vue&type=script&lang=js"
import style0 from "./EpopsModal.vue?vue&type=style&index=0&id=13640d03&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13640d03",
  null
  
)

export default component.exports